<template>
  <section class="pb-4">
    <div class="container">
      <div class="row mb-5">
        <div class="col-8 offset-2 text-center">
          <h1> Déclarer un sinistre </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div
              class=" card-body rounded-4 p-4
                box-shadow-yellow-400
                box-shadow-hover-yellow-400"
            >
              <div class="row">
                <div class="col-1">
                  <v-icon
                    icon="chevron-left"
                    class="cursor-pointer"
                    @click="() => $router.back()"
                  />
                </div>
                <div class="col-10 text-center">
                  <h4 class="mb-4">
                    Votre sinistre concerne...
                  </h4>
                </div>
              </div>
              <div class="row d-flex flex-row justify-content-center">
                <div
                  v-for="card in cardsFilteredByOwnedProducts"
                  :key="card.title"
                  class="col-auto my-2"
                  @mouseover="card.hover = true"
                  @mouseleave="card.hover = false"
                >
                  <div
                    class="mx-auto card shadow"
                    style="height:250px; width: 250px"
                  >
                    <router-link
                      v-slot="{ navigate }"
                      :to="`/client/claim/declaration/${card.path}`"
                      custom
                    >
                      <div
                        class="card-body p-3 cursor-pointer d-flex"
                        @click="(event) => setProduct(card.path) && navigate(event)"
                      >
                        <div class="d-flex flex-column mx-auto">
                          <div class="lead fw-bold mx-auto text-center">
                            {{ card.title }}
                          </div>
                          <div class="text-center mx-auto mt-auto mb-4">
                            <img
                              :src="`${aws}/${card.icon}${card.hover ? '-broken' : ''}.svg`"
                              class="img-fluid"
                            >
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import { uniqBy } from 'lodash-es';

export default {
  name: 'ClaimTypeChoice',
  data() {
    return {
      cards: [
        {
          title: 'Vos locaux',
          icon: 'lamp',
          path: 16,
          hover: false,
        },
        {
          title: 'Votre responsabilité civile professionnelle',
          icon: 'umbrella',
          path: 1,
          hover: false,
        },
        {
          title: 'Autre',
          icon: 'cloud',
          path: 0,
          hover: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      contracts: 'contracts/get',
    }),
    productsOwnedList() {
      const contracts = this.contracts
        .filter(({ status }) => status === 'ACTIVE')
        || [];
      return uniqBy(contracts, 'productId')
        .map(({ productId }) => parseInt(productId, 10))
        .concat([0]);
    },
    cardsFilteredByOwnedProducts() {
      return this.cards
        .filter(({ path }) => this.productsOwnedList.includes(path));
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/dashboard/svg/claim`,
  },
  methods: {
    setProduct(productId) {
      return this.$store.dispatch('claim/setValue', { productId });
    },
  },
};
</script>
